import { render, staticRenderFns } from "./AlipayFlowSearch.vue?vue&type=template&id=55b52030&scoped=true"
import script from "./AlipayFlowSearch.vue?vue&type=script&lang=js"
export * from "./AlipayFlowSearch.vue?vue&type=script&lang=js"
import style0 from "./AlipayFlowSearch.vue?vue&type=style&index=0&id=55b52030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b52030",
  null
  
)

export default component.exports